import React from 'react'
import SchoolAddTeachers from '../../features/school/SchoolAddTeachers'

const SchoolAddTeachersPage = () => {
    return (
        <SchoolAddTeachers />
    )
}

export default SchoolAddTeachersPage
